// Generated by tools/icons/generate.mjs. Edit the SVG source and manifest instead.
import * as React from "react"
const CheckMarkCircleIcon = /* @__PURE__ */ React.forwardRef<SVGSVGElement, React.ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M16.9264 9.38337C17.2072 9.07883 17.1879 8.60434 16.8834 8.32358C16.5788 8.04282 16.1043 8.06209 15.8236 8.36663L10.603 14.0293L8.16708 11.4817C7.88082 11.1823 7.40607 11.1717 7.10669 11.4579C6.8073 11.7442 6.79666 12.2189 7.08292 12.5183L9.70288 15.2584C10.2014 15.7798 11.0365 15.7722 11.5254 15.2418L16.9264 9.38337Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5761 12C20.5761 16.7365 16.7365 20.5761 12 20.5761C7.26353 20.5761 3.42386 16.7365 3.42386 12C3.42386 7.26353 7.26353 3.42386 12 3.42386C16.7365 3.42386 20.5761 7.26353 20.5761 12Z"
          fill="currentColor"
        />
      </svg>
    )
  }
)
CheckMarkCircleIcon.displayName = "CheckMarkCircleIcon"
export { CheckMarkCircleIcon }
